import type { NotificationType } from '@/types'

/**
 * Maps notification types to their relevant frontend pages.
 * Used by the notification panel and toast actions for navigation.
 */
export const NOTIFICATION_ROUTES: Record<NotificationType, string> = {
  campaign_completed: '/campaigns',
  campaign_failed: '/campaigns',
  flow_error: '/flows',
  flow_completed: '/flows',
  new_message: '/inbox',
  low_balance: '/settings/billing',
  team_invite: '/settings/team',
  chat_assigned: '/inbox',
  chat_escalated: '/inbox',
  system_update: '/notifications',
  webhook_failure: '/integrations',
  import_completed: '/import-export',
  import_failed: '/import-export',
  export_completed: '/import-export',
  export_failed: '/import-export',
}
